import { Fragment, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";

import { Card } from "reactstrap";
import { Btn, LI } from "../../../AbstractElements";

import { logout } from "../../../MyApi/logout";


import { toast } from "react-toastify";
import AuthContext from "../../../_helper/auth";
import LockLogoutSvg from "../../../Components/Common/svg/locklogout";
import LogOutModal from "../../../Components/UI/logoutModal";

const LogoutClass = () => {
  const {authenticated,setAuthenticated}=useContext(AuthContext)
  const [isModalOpen,setIsModalOpen]=useState(false)
  const {t}=useTranslation()
  const navigate = useNavigate(); 
  const openModal =()=>{
setIsModalOpen(true)
  }

  const closeModal =()=>{
    setIsModalOpen(false)
  }
  const mutation = useMutation("logout", (data) => logout(data), {
    onSuccess: () => {  
       localStorage.clear(); 
      setAuthenticated(false) 
  
      toast.success(t("Logout successfully")); 

    },
  });
  

  const handleLogout = () =>{
    const token = localStorage.getItem("token");
    mutation.mutate({
      token,
    });
  };
  return (    
    <Fragment>
      <LI attrLI={{ className: "border-1 d-flex flex-column p-0 logout-container ", onClick: openModal  }} 
        >
        <Btn
          attrBtn={{
            as: Card.Header,
            className: "text-danger d-flex gap-3 align-items-center px-3 py-2 m-auto mb-0   w-100",
            color: "default",
          
          }}
          
        >

          <LockLogoutSvg /> 
          {t("Log out")}
        
        </Btn>
      </LI>
      <LogOutModal handleLogout={handleLogout} isLoading={mutation.isLoading} closeModal={closeModal} isModalOpen={isModalOpen}/>
    </Fragment>
  );
};

export default LogoutClass;
